(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("zeta-dom"), require("jquery"), require("waterpipe"), require("jq-scrollable"));
	else if(typeof define === 'function' && define.amd)
		define("brew-js", ["zeta-dom", "jquery", "waterpipe", "jq-scrollable"], factory);
	else if(typeof exports === 'object')
		exports["brew-js"] = factory(require("zeta-dom"), require("jquery"), require("waterpipe"), require("jq-scrollable"));
	else
		root["brew"] = factory(root["zeta"], root["jQuery"], root["waterpipe"], root["jq-scrollable"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__231__, __WEBPACK_EXTERNAL_MODULE__914__, __WEBPACK_EXTERNAL_MODULE__87__, __WEBPACK_EXTERNAL_MODULE__649__) {
return 